import {useMe} from '@/features/authentication/queries/useMe'
import {QUERY_KEYS} from '@/features/goal/queries/keys.ts'
import {getTypesOfGoal} from '@/features/goal/services/goal.http.ts'
import {useQuery} from '@tanstack/react-query'

export const useGoalsTypeV3 = () => {
    const {data: user, loggedIn} = useMe()
    return useQuery({
        queryKey: [QUERY_KEYS.goalType],
        queryFn: getTypesOfGoal,
        enabled: !!user && !!loggedIn
    })
}
